import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { App } from "./App";

import "./styles/tokens.css";
import "./styles/reset.css";
import "./styles/suite.css";
import "./styles/funnel.css";
import "./styles/query-ask.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
);
